
export const getIsDataPresent = (data) => {
  return !!data.length
}